module.exports = "/src/views/player/help/images/lost.jpg";